import diff from 'deep-diff';

import { Action } from './actions';

export const reducer = (state, action) => {

  switch (action.type) {
    case Action.UpdateProfile: {
      if (diff(state.profile, action.payload)) {
        return {
          ...state,
          profile: action.payload
        };
      }

      return state;
    }

    case Action.UpdateUnreadCount:
      return {
        ...state,
        unreadCount: {
          ...state.unreadCount,
          [action.payload.source]: action.payload.count
        }
      };

    default:
      return state;
  }
};
